module.exports = __webpack_public_path__ + "static/img/product24.8acf5e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product24.png
// module id = ilMK
// module chunks = 13